import React from "react";
import "./App.css";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import Homepage from "./Component/HomePage/Homepage";
import Studenthomepage from "./Component/Students/HomePage/StudentHomePage";
import Teacher from "./Component/Teacher/Teacher";
import Grammer from "./Component/Students/Grammer/Grammer";
// import Words from "./Component/Students/Words/Words";
// import Aone from "./Component/Students/Words/LevelA/AOne";
const App = () => {
  return (
    <div className="App">
      <Router>
        <Routes>
          <Route path="/" element={<Homepage />} />
          <Route path="/Studenthomepage" element={<Studenthomepage />} />
          <Route path="/Grammer" element={<Grammer />} />
          <Route path="/Teacher" element={<Teacher />} />
          {/* <Route path="/Words" element={<Words />} /> */}
          {/* <Route path="/Aone" element={<Aone />} /> */}
        </Routes>
      </Router>
    </div>
  );
};

export default App;
